<template>
  <ul class="uk-nav uk-nav-primary uk-nav-left uk-margin-auto-vertical" v-if="$store.state.user.claims">
    <router-link v-if="isDashboardUser"
      :to="{ name: 'Dashboard' }"
      tag="li"
      active-class="uk-active"
    >
      <a @click="hideOffcanvasMenu">Dashboard</a>
    </router-link>
    <router-link v-if="isSurveysUser"
      :to="{ name: 'Surveys' }"
      tag="li"
      active-class="uk-active"
    >
      <a @click="hideOffcanvasMenu">Surveys</a>
    </router-link>
    <li active-class="uk-active" class="uk-margin-large-top">
      <a @click.prevent="logout">Log out</a>
    </li>
  </ul>
</template>

<script>
import UIkit from "uikit";

export default {
  name: "NavList",
  data: () => ({
      isDashboardUser: true,
      isSurveysUser: true
  }),
  methods: {
    logout() {
      this.hideOffcanvasMenu();
      this.$store.dispatch("user/logout");
      location.reload();
    },
    hideOffcanvasMenu() {
      UIkit.offcanvas("#offcanvas-slide").hide();
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  mounted() {
    console.log("NavList mounted"); 
  },
  watch: {
    '$store.state.user': {
      handler(val) {
        console.log(val);
        console.log("User change catched in NavList");
        this.isDashboardUser = !!this.$store.state.user.role;
        this.isSurveysUser = !!this.$store.state.user.role;
      },
      deep: true
    }
  }
};
</script>
